export function benefitFundLink(fundUrl) {
  if (!fundUrl) return ''
  return `//fund.stockstar.com${fundUrl}`
}

export function stockstarCodeLink(code) {
  const normalized = String(code || '').replace(/\D/g, '').padStart(6, '0').slice(-6)
  if (!/^\d{6}$/.test(normalized)) return ''
  return `//stock.quote.stockstar.com/${normalized}.shtml`
}

export function eastmoneyCodeLink(row) {
  const code = row?.code
  if (/^\d{6}$/.test(code)) {
    const prefix = code.substring(0, 3)
    if (['600', '601', '603', '605'].includes(prefix)) {
      return `//quote.eastmoney.com/sh${code}.html`
    }
    if (['688', '689'].includes(prefix)) {
      return `//quote.eastmoney.com/kcb/${code}.html`
    }
    if (['000', '001', '002', '003', '004', '300', '301'].includes(prefix)) {
      return `//quote.eastmoney.com/sz${code}.html`
    }
    if (['920'].includes(prefix)) {
      return `//quote.eastmoney.com/bj/${code}.html`
    }
  }
  return row?.codeLink || stockstarCodeLink(code)
}
